import React from 'react';
import PropTypes from 'prop-types';

import GetUserQuery from 'components/queries/GetUserQuery';

const CanPerform = ({ afterSalesShortcut, children }) => (
  <GetUserQuery>
    {({
      data: {
        me: { afterSalesShortcuts }
      }
    }) => children(afterSalesShortcuts.includes(afterSalesShortcut))}
  </GetUserQuery>
);

CanPerform.propTypes = {
  afterSalesShortcut: PropTypes.string.isRequired,
  children: PropTypes.func.isRequired
};

export default CanPerform;
